import { BetweenItemDropBorder } from 'components/BetweenItemDropBorder';
import {
  CUSTOM_DRAGGABLE_ITEM_TYPES,
  DROP_RESULT_TYPES,
} from 'components/customDragLayer/const';
import { useDrop } from 'components/customDragLayer/hooks/useDrop';
import type {
  DraggableItem,
  DropResult,
} from 'components/customDragLayer/types';

type AcceptableItemType = typeof CUSTOM_DRAGGABLE_ITEM_TYPES.RULES_RESOLUTION;

type BetweenResolutionDropBorderProps = {
  side: 'top' | 'bottom';
  resolutionIndex: number;
  onReorderResolutions: (oldIndex: number, newIndex: number) => void;
};

export const BetweenResolutionDropBorder = ({
  side,
  resolutionIndex,
  onReorderResolutions,
}: BetweenResolutionDropBorderProps) => {
  const handleDrop = (
    droppedItem: DraggableItem<AcceptableItemType>,
  ): DropResult | undefined => {
    if (
      droppedItem.draggableItemType ===
      CUSTOM_DRAGGABLE_ITEM_TYPES.RULES_RESOLUTION
    ) {
      const oldIndex = droppedItem.resolution.resolutionIndex;
      const newIndex = resolutionIndex;

      // Check if dropping in same position (no-op)
      if (newIndex === oldIndex || newIndex === oldIndex + 1) {
        return {
          dropResultType: DROP_RESULT_TYPES.RULES_REORDER_RESOLUTIONS,
          didReorder: false,
        };
      }

      onReorderResolutions(oldIndex, newIndex);

      return {
        dropResultType: DROP_RESULT_TYPES.RULES_REORDER_RESOLUTIONS,
        didReorder: true,
      };
    }

    return undefined;
  };

  const [{ canDrop, isOver }, connectDropTarget] = useDrop({
    accept: CUSTOM_DRAGGABLE_ITEM_TYPES.RULES_RESOLUTION,
    collect: (monitor) => ({
      canDrop: monitor.canDrop(),
      isOver: monitor.isOver({ shallow: true }),
    }),
    onDropEnd: handleDrop,
  });

  return (
    <BetweenItemDropBorder
      ref={connectDropTarget}
      side={side}
      canDrop={canDrop}
      isOver={isOver}
      dropAreaProps={{ height: 5 }}
    />
  );
};
